import { JSEncrypt } from 'jsencrypt';

const RES_PUBLIC_KEY = `
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCyJdVXw+TvnFnE2ElRmJflkFO2
  0wSjJzS+XV887at9jTKa+EhpSg7aCNgCcFQfCEVpHVKegR4s02+4RH4q+y0gP/yI
  jAdyKAh16gC9NiM83WpN/PfBCOon55bIJI5G0OBi1I0el+3rpBqtRRzlRfiOXi4C
  6pmO0ayVmP5rVNASsQIDAQAB
  `;

const encrypt = new JSEncrypt();
encrypt.setPublicKey(RES_PUBLIC_KEY);
const MAX_ENCRYPT_SIZE = 117;

const stringSplitFunc = str => {
  if (str.length < MAX_ENCRYPT_SIZE) return [str];
  const strArr = [];
  let len = 0;
  // eslint-disable-next-line
  while (true) {
    const endSize = MAX_ENCRYPT_SIZE + len;
    const s = str.substring(len, endSize);
    if (s.length === 0) break;
    strArr.push(s);
    len = endSize;
  }
  return strArr;
};
const stringArrayEncryptFunc = strArr => strArr.map(item => encrypt.encrypt(item));
const encryptFn = (val, withTimeStamp? = false) => {
  let jsonStringify = val;
  if (typeof val !== 'string') {
    jsonStringify = JSON.stringify(val);
  }
  if (withTimeStamp) {
    // 在数据的尾部带上毫秒级别时间戳
    jsonStringify += `#${new Date().getTime()}`;
  }
  const stringSplit = stringSplitFunc(jsonStringify);
  const a = stringArrayEncryptFunc(stringSplit).join(',');
  return a;
};
export default encryptFn;
